var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5017 11.0324L11.1975 8.72818C11.6164 7.89027 11.8957 6.91272 11.8957 5.93516C11.8957 2.65337 9.24235 0 5.96055 0C2.67876 0 0.0253906 2.65337 0.0253906 5.93516C0.0253906 9.21696 2.67876 11.8703 5.96055 11.8703C6.93811 11.8703 7.91567 11.591 8.75357 11.1721L11.0578 13.4763C11.7561 14.1746 12.8035 14.1746 13.5017 13.4763C14.1301 12.7781 14.1301 11.7307 13.5017 11.0324ZM5.96055 10.4738C3.44684 10.4738 1.4219 8.44888 1.4219 5.93516C1.4219 3.42145 3.44684 1.39651 5.96055 1.39651C8.47427 1.39651 10.4992 3.42145 10.4992 5.93516C10.4992 8.44888 8.47427 10.4738 5.96055 10.4738Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3ef86777278450c32b03601296b1de38.svg";
export { ForwardRef as ReactComponent };